import { BaseDevice, CustomLayout } from '../base_device'
import { EffectIndex, KK } from '@/define/define'
import list_icon from '@/assets/img/device/al87/list_icon.png'
import { LightEffectMode, LightEffectModeType } from '@/define/light'
import { LIGHT_EFFECT_LIST_IROKN_ST_V1 } from '../light/light_effect_list'
export class Mg87 extends BaseDevice {
  lightEffectList: { [name: LightEffectModeType]: EffectIndex } = LIGHT_EFFECT_LIST_IROKN_ST_V1
  y_number: number = 6
  name: string = 'MG87'
  icon: string = list_icon
  width: number = 808
  inoperableKeys: KK[] = [0x3b]

  customLayout: CustomLayout = {
    0x0c: this.createSquare(45.6, 2),
    0x24: this.createSquare(22.9, 2),
    0x3c: this.createSquare(22.9, 2),
    0x54: this.createSquare(4, 2),
    0x1: this.createSquare(2, this.y_number),
    0x7: this.createSquare(2, this.y_number),
    0xd: this.createSquare(2, this.y_number),
    0x13: this.createSquare(2, this.y_number),
    0x19: this.createSquare(2, this.y_number),
    0x1f: this.createSquare(2, this.y_number),
    0x25: this.createSquare(2, this.y_number),
    0x2b: this.createSquare(2, this.y_number),
    0x31: this.createSquare(2, this.y_number),
    0x37: this.createSquare(2, this.y_number),
    0x3d: this.createSquare(2, this.y_number),
    0x43: this.createSquare(2, this.y_number),
    0x49: this.createSquare(2, this.y_number),
    0x4f: this.createSquare(2, 6, 83.2),
    0x55: this.createSquare(4, this.y_number),
    0x5b: this.createSquare(2, this.y_number),
    0x61: this.createSquare(2, this.y_number),
    0x2: this.createSquare(2, 2, 62.4),
    0x50: this.createSquare(2, 2, 62.4),
    0x56: this.createSquare(4, 2),
    0x3: this.createSquare(2, 2, 77),
    0x51: this.createSquare(2, 2, 91.5),
    0x4: this.createSquare(2, 2, 99.8),
    0x52: this.createSquare(2, 2, 112.3),
    0x5e: this.createSquare(47.8, 2),
    0x5: this.createSquare(2, 2, 54.1),
    0xb: this.createSquare(2, 2, 54.1),
    0x11: this.createSquare(2, 2, 54.1),
    0x23: this.createSquare(2, 2, 256),
    0x35: this.createSquare(2, 2, 54.1),
    0x3b: this.createSquare(2, 2, 54.1),
    0x41: this.createSquare(2, 2, 54.1),
    0x53: this.createSquare(2, 2, 54.1),
    0x59: this.createSquare(4, 2),
  }
}
